export default __webpack_public_path__ + "static/page404-7f9a210f33fc409082cecd3eddc08c31.svg";